import { ThumbnailContainer, ThumbnailItem, ThumbnailImage } from './styles';
import { ThumbnailLoadingContainer } from '../styles';
import { CircularProgress } from '@mui/material';
import { ImageTypeBadge } from './ImageTypeBadge';

interface ImageWithId {
  id: string | number;
  src?: string;
  name?: string;
  isLoading?: boolean;
  type?: string;
}

interface ThumbnailListProps {
  imagesWithIds: ImageWithId[];
  currentIndex: number;
  handleThumbnailClick: (index: number) => void;
}

export const ThumbnailList = ({
  imagesWithIds,
  currentIndex,
  handleThumbnailClick,
}: ThumbnailListProps) => (
  <ThumbnailContainer>
    {imagesWithIds.map((img: ImageWithId, index: number) => (
      <ThumbnailItem
        key={img.id}
        isSelected={index === currentIndex}
        onClick={() => handleThumbnailClick(index)}
        sx={{
          cursor: img.isLoading ? 'default' : 'pointer',
          opacity: img.isLoading ? 0.7 : 1,
        }}
      >
        {img.isLoading ? (
          <ThumbnailLoadingContainer>
            <CircularProgress size={24} />
          </ThumbnailLoadingContainer>
        ) : img.src ? (
          <ThumbnailImage src={img.src} alt={`Thumbnail ${img.name}`} />
        ) : (
          <ThumbnailLoadingContainer>
            No thumbnail images available
          </ThumbnailLoadingContainer>
        )}

        {!img.isLoading && <ImageTypeBadge type={img.type} />}
      </ThumbnailItem>
    ))}
  </ThumbnailContainer>
);